export class AppParams {
  public categoryName: string;
  public institutionId: number;
  constructor() {
    this.categoryName = null;
    this.institutionId = -1;
  }
}
